import { render, staticRenderFns } from "./ResourcePreview.vue?vue&type=template&id=3df73884&scoped=true"
import script from "./ResourcePreview.vue?vue&type=script&lang=js"
export * from "./ResourcePreview.vue?vue&type=script&lang=js"
import style0 from "./ResourcePreview.vue?vue&type=style&index=0&id=3df73884&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df73884",
  null
  
)

export default component.exports